<template>
  <div>
    <!-- content -->
    <v-container class="mb-10">
      <v-row v-if="loading">
        <v-col cols="12" v-for="item in 6" :key="item">
          <v-skeleton-loader type="list-item-avatar-three-line" />
        </v-col>
      </v-row>
      <div v-if="!loading && areasListFiltered.length > 0">
        <v-row class="mt-2">
          <v-col
            cols="12"
            xl="4"
            lg="4"
            md="6"
            sm="6"
            xs="12"
            class="mb-5"
            v-for="area in areasListFiltered"
            :key="area.id"
          >
            <area-item :area="area"></area-item>
          </v-col>
        </v-row>
      </div>
      <v-row
        v-else
        id="advice"
        class="full--height mt-2"
        align="end"
        justify="center"
      >
        <v-col class="full--height">
          <p class="text-center">{{ translations.label_no_areas }}</p>
        </v-col>
      </v-row>
    </v-container>
    <!-- copyright -->
    <v-footer
      class="text-caption text-center d-flex justify-center"
      fixed
      inset
    >
      D.R. © Solena Ag, Inc. {{new Date().getFullYear()}}
    </v-footer>
  </div>
</template>

<script>
import AreaItem from "@/components/territory/AreaItem.vue";

import { mapActions, mapState, mapMutations, mapGetters } from "vuex";

export default {
  components: {
    AreaItem,
  },
  data() {
    return {
      page: 0,
      isMoreData: true,
      loading: false,
      organizationId: "",
      searchArea: "",
      openSearch: false,
      currentSearch: null,
      areasListFiltered: [],
      busyGettingData: false,
    };
  },
  async mounted() {
    this.SET_APPBAR_OPTIONS({
      leftButton: "back-arrow",
      funcLeftButton: this.goBack,
      rightButton: "search",
      funcRightButton: this.setAreasList,
    });
    let user = JSON.parse(localStorage.getItem("user"));
    if (user.role == "ORG_USER" || user.role == "ORG_USER_ADMIN") {
      this.organizationId = localStorage.getItem("organizationId");
    } else {
      let client = JSON.parse(localStorage.getItem("client"));
      if (client && client.companyName) {
        this.SET_CLIENT(client.companyName);
      }
      this.organizationId = localStorage.getItem("clientId");
    }
    // if (this.soilAreas && this.soilAreas.length <= 0) {
    await this.getSoilAreas();
    // } else {
    //   let pagedSoilAreas = this.paginate(this.soilAreas, 50, this.page);
    //   this.areasListFiltered = pagedSoilAreas;
    //   this.page++;
    // }

    this.loading = false;
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  async created() {},
  watch: {
    search(value) {
      this.setAreasList(value);
    },
  },
  computed: {
    ...mapGetters("session", ["currentTranslations"]),
    translations() {
      return this.currentTranslations;
    },
    ...mapState("areasList", ["soilAreas", "search"]),
  },
  methods: {
    ...mapActions("areasList", ["getAreaPaged", "getAreaFiltered"]),
    ...mapMutations(["SET_APPBAR_OPTIONS", "SET_LOADER"]),
    ...mapMutations("user", ["SET_CLIENT"]),
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),

    async getSoilAreas() {
      this.SET_LOADER(true);
      try {
        const response = await this.getAreaPaged({
          organizationId: this.organizationId,
          page: this.page,
        });
        if (response) {
          this.loading = false;
          this.areasListFiltered = response.soilAreas;
          this.page++;
        } else {
          this.SET_ALERT_TYPE({
            visible: true,
            type: "error",
            text: this.translations.advice_error,
            timeout: 4000,
          });
        }
      } catch (error) {
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: this.translations.advice_error,
          timeout: 4000,
        });
      }
      this.SET_LOADER(false);
    },

    goBack() {
      this.$router.back();
      // this.$router.push(`/territory`);
    },

    // filter areas
    async setAreasList(value) {
      if (!value) {
        this.page = 0;
        this.isMoreData = true;
        this.currentSearch = null;
        this.areasListFiltered = [];
        this.scrollTop();
        await this.getSoilAreas();
      } else {
        try {
          this.currentSearch = value;
          this.page = 0;
          this.areasListFiltered = [];
          this.scrollTop();
          this.isMoreData = true;
          let response = await this.getAreaFiltered({
            organizationId: this.organizationId,
            page: this.page,
            name: value,
          });
          if (response) {
            this.loading = false;
            this.areasListFiltered = response.soilAreas;
            this.page++;
          } else {
            this.SET_ALERT_TYPE({
              visible: true,
              type: "error",
              text: this.translations.advice_error,
              timeout: 4000,
            });
          }
        } catch (e) {
          this.SET_ALERT_TYPE({
            visible: true,
            type: "error",
            text: this.translations.advice_error,
            timeout: 4000,
          });
        }
      }
    },
    async handleScroll() {
      try {
        if (
          window.scrollY + window.innerHeight >=
          document.body.scrollHeight - 500
        ) {
          if (this.busyGettingData) return;
          if (this.isMoreData && !this.currentSearch) {
            this.busyGettingData = true;
            const response = await this.getAreaPaged({
              organizationId: this.organizationId,
              page: this.page,
            });
            if (response) {
              this.loading = false;
              if (response.soilAreas.length > 0) {
                this.areasListFiltered.push(...response.soilAreas);
                this.page++;
              } else {
                this.isMoreData = false;
              }
            } else {
              this.SET_ALERT_TYPE({
                visible: true,
                type: "error",
                text: this.translations.advice_error,
                timeout: 4000,
              });
            }
          } else if (this.isMoreData && this.currentSearch) {
            this.busyGettingData = true;
            const response = await this.getAreaFiltered({
              organizationId: this.organizationId,
              page: this.page,
              name: this.currentSearch,
            });
            if (response) {
              this.loading = false;
              if (response.soilAreas.length > 0) {
                this.areasListFiltered.push(...response.soilAreas);
                this.page++;
              } else {
                this.isMoreData = false;
              }
            } else {
              this.SET_ALERT_TYPE({
                visible: true,
                type: "error",
                text: this.translations.advice_error,
                timeout: 4000,
              });
            }
          }
        }
      } catch (e) {
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: this.translations.advice_error,
          timeout: 4000,
        });
      }
      this.busyGettingData = false;
    },
    scrollTop() {
      window.scrollTo(0, 0);
    },
    // paginate(array, page_size, page_number) {
    //   // human-readable page numbers usually start with 1, so we reduce 1 in the first argument
    //   return array.slice(
    //     (page_number - 1) * page_size,
    //     page_number * page_size
    //   );
    // },
  },
};
</script>

<style scoped>
.fix-down {
  width: 100%;
  /* height: 80vh; */
  position: absolute;
  margin: 2px 0;
  bottom: 0;
  text-align: center;
}
</style>
